import { render, staticRenderFns } from "./graph-node.vue?vue&type=template&id=82e48e5e&scoped=true"
import script from "./graph-node.vue?vue&type=script&lang=js"
export * from "./graph-node.vue?vue&type=script&lang=js"
import style0 from "./graph-node.vue?vue&type=style&index=0&id=82e48e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e48e5e",
  null
  
)

export default component.exports